export const EDIT_ENTITY_MAX_COUNT = 10;
